'use client';

import { LoadingIndicator } from '@petsmart-ui/sparky';

import { useCvvChallenge } from './CVVChallengeProvider';
import { CvvForm } from './CvvForm';
import type { CVVChallengeProps } from './types';
import { useCvvForm } from './useCvvForm';

import '@adyen/adyen-web/styles/adyen.css';
import './CVVChallenge.scss';

export function CVVChallenge({ card, address, onVerified }: Readonly<CVVChallengeProps>) {
    const { isLoading } = useCvvChallenge();
    const { isSubmitting, errorMessage, submitCvv, clearError } = useCvvForm({ card, onVerified });

    return (
        <div className="cvv-challenge" data-testid="cvv-challenge">
            {isLoading ? (
                <LoadingIndicator data-testid="cvv-challenge-loading" />
            ) : (
                <CvvForm
                    card={card}
                    address={address}
                    isSubmitting={isSubmitting}
                    errorMessage={errorMessage}
                    onSubmit={submitCvv}
                    onCvvChange={clearError}
                />
            )}
        </div>
    );
}
